import { Info } from 'lucide-react';
import { NO_PHI_NOTICE_TEXT, NO_PHI_CHAT_TEXT } from './noPhiNoticeText';

/**
 * The shared "do not upload patient information" notice. Shown next to every
 * place a user gives the platform a file or pasted text, BEFORE they pick a
 * file. It informs; it never blocks (no checkbox, no confirmation).
 *
 * The wording is exported so tests and both variants share one source.
 */
export { NO_PHI_NOTICE_TEXT, NO_PHI_CHAT_TEXT };

interface NoPhiNoticeProps {
  /** 'full' (default) for uploads and pasted documents; 'chat' for a one-line chat note. */
  variant?: 'full' | 'chat';
  className?: string;
}

export default function NoPhiNotice({ variant = 'full', className = '' }: NoPhiNoticeProps) {
  if (variant === 'chat') {
    return (
      <p
        role="note"
        data-testid="no-phi-notice"
        className={`flex items-center gap-1.5 text-xs text-amber-800 ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <Info className="h-3.5 w-3.5 flex-shrink-0" aria-hidden="true" />
        <span>{NO_PHI_CHAT_TEXT}</span>
      </p>
    );
  }
  return (
    <div
      role="note"
      data-testid="no-phi-notice"
      className={`flex gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-left text-sm text-amber-900 ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      <Info className="h-4 w-4 mt-0.5 flex-shrink-0" aria-hidden="true" />
      <p>{NO_PHI_NOTICE_TEXT}</p>
    </div>
  );
}
